import styled from 'styled-components'

import Button from 'shared/components/Button'

export const ContainerForm = styled.div`
  display: flex;

  flex-direction: column;
  align-items: center;
  justify-content: center;

  input {
    min-width: 513px;
  }
`

export const StyledButton = styled(Button)`
  position: absolute;
  bottom: 20px;

  @media (max-width: 1377px) {
    position: relative;
    bottom: -150px;
  }

  @media (max-height: 668px) {
    bottom: -120px;
  }
`
